/** Static marketing copy and illustrative KPIs (Phase 2a). */

export const MARKETING_KPIS = [
  { label: 'Mandates audited', value: '2,840', note: 'Illustrative' },
  { label: 'Clearance rate', value: '68.4%', note: 'Illustrative' },
  { label: 'Avg Echo Index', value: '74.2', note: 'Illustrative' },
  { label: 'Board exports', value: '12.4k', note: 'Illustrative' },
] as const;

export const EVIDENCE_POINTS = [
  {
    title: 'Behavioural neuroscience',
    body: 'Echo Index methodology is grounded in 30 years of audience attention research, calibrated against 7,200+ creative works.',
  },
  {
    title: 'Deterministic scoring',
    body: 'V7 pillar engine produces reproducible mandate fit, structural integrity, and commercial signal metrics — not generative opinion.',
  },
  {
    title: 'Forensic audit trail',
    body: 'Every screenplay receives SCR-ID registry entry, clearance status, and exportable board evidence.',
  },
  {
    title: 'Data discretion',
    body: 'Screenplays are processed for audit output only. No long-term script storage. SOC 2 Type II aligned controls.',
  },
] as const;

export const DESIGNED_FOR = [
  {
    title: 'Studios & streamers',
    body: 'Slate clearance decisions with mandate-weighted Echo Index thresholds and development mandate inheritance.',
    tags: ['Slate ops', 'Board review', 'Mandate fit'],
  },
  {
    title: 'Production companies',
    body: 'Ingest screenplays at volume, track rewrite vs cleared distribution, and export forensic scorecards.',
    tags: ['Development', 'Script registry', 'Audit runs'],
  },
  {
    title: 'Agencies & financiers',
    body: 'Commercial signal and narrative volatility metrics for package assessment before commitment.',
    tags: ['Due diligence', 'Echo Index', 'Risk bands'],
  },
] as const;

export const ENTERPRISE_TIERS = [
  {
    id: 'individual',
    name: 'Workspace',
    seats: '1',
    mandates: '3',
    audits: '25 / mo',
    price: 'Self-serve',
    cta: 'Register',
    path: '/register',
  },
  {
    id: 'team',
    name: 'Team',
    seats: '5–25',
    mandates: 'Unlimited',
    audits: '250 / mo',
    price: 'Contact',
    cta: 'Inquire',
    path: '/enterprise',
    highlight: true,
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    seats: '25+',
    mandates: 'Unlimited',
    audits: 'Custom SLA',
    price: 'Procurement',
    cta: 'Talk to sales',
    path: '/enterprise',
  },
] as const;

export const FOOTER_COLUMNS = {
  product: [
    { label: 'NucliusAudit', href: '/login' },
    { label: 'Echo Index Reports', href: '/login' },
    { label: 'Development Mandates', href: '/login' },
    { label: 'Enterprise Access', href: '/enterprise' },
  ],
  methodology: [
    { label: 'Echo Index V7', href: '#evidence' },
    { label: 'Attention curve', href: '#evidence' },
    { label: 'Clearance thresholds', href: '#evidence' },
  ],
  security: [
    { label: 'SOC 2 Type II', href: '#' },
    { label: 'TLS 1.3', href: '#' },
    { label: 'Data retention', href: '#' },
  ],
  legal: [
    { label: 'Terms', href: '#' },
    { label: 'Privacy', href: '#' },
    { label: 'Contact', href: '/enterprise' },
  ],
} as const;
